const t = require("react-imported-component");
module.exports = t.lazy;